import React, { useState } from "react";
import Aside from "../Dashboard/Aside/Aside";
import { Outlet } from "react-router-dom";
import DashboardSidebar from "../../components/DashboardSidebar/DashboardSidebar";
import userRoles from "../../config/userRoles";

const Payroll = () => {
  const [submenu, setSubmenu] = useState([
    {
      text: "My Payroll",
      link: "/payroll/my-payroll/payslip",
      roles: [userRoles.TENANTADMIN, userRoles.HR, userRoles.MANAGER, userRoles.EMPLOYEE,userRoles.FINANCEADMIN],
      icon: "ico-down",
      menu: [
        {
          text: "Pay Slips",
          link: "/payroll/my-payroll/payslip",
          roles: [userRoles.TENANTADMIN, userRoles.HR, userRoles.MANAGER, userRoles.EMPLOYEE,userRoles.FINANCEADMIN],
        },
        // {
        //   text: "Reimbursement",
        //   link: "#",
        //   roles: [1, 2, 4, 6],
        // },
        // {
        //   text: "Ytd Report",
        //   link: "#",
        //   roles: [1, 2, 4, 6],
        // },
        // {
        //   text: "Investment",
        //   link: "#",
        //   roles: [1, 2, 4, 6],
        // },
        // {
        //   text: "FBP Declarations",
        //   link: "#",
        //   roles: [1, 2, 4, 6],
        // },
        // {
        //   text: "Loan",
        //   link: "#",
        //   roles: [1, 2, 4, 6],
        // },
      ],
      status: false,
    },
    {
      text: "Employee Payroll",
      link: "/payroll/employee-payroll/employee-payroll-process",
      icon: "ico-down",
      roles: [userRoles.TENANTADMIN, userRoles.HR, userRoles.FINANCEADMIN],

      menu: [
        {
          text: "Dashboard",
          link: "/payroll/employee-payroll/employee-payroll-process",
          roles: [userRoles.TENANTADMIN, userRoles.HR, userRoles.FINANCEADMIN],
        },
        // {
        //   text: "Adjust And Publish",
        //   link: "/payroll/employee-payroll/review-and-publish",
        //   roles: [userRoles.TENANTADMIN, userRoles.HR, userRoles.FINANCEADMIN],
        // },
        // {
        //   text: "Published Payroll View",
        //   link: "/payroll/employee-payroll/view-and-download",
        //   roles: [userRoles.TENANTADMIN, userRoles.HR, userRoles.FINANCEADMIN],
        // },
            {
          text: " Bank Statement Management",
          link: "/payroll/employee-payroll/bank-statement-management",
          roles: [userRoles.TENANTADMIN, userRoles.HR, userRoles.FINANCEADMIN],
        },
        // {
        //   text: "Approval",
        //   link: "/payroll/employee-payroll/employee-payroll-approval",
        //   roles: [userRoles.TENANTADMIN, userRoles.HR, userRoles.FINANCEADMIN],
        // },
        // {
        //   text: "Pay Runs",
        //   link: "#",
        //   roles: [1, 2, 4, 6],
        // },
        // {
        //   text: "Form 16",
        //   link: "#",
        //   roles: [1, 2, 4, 6],
        // },
        // {
        //   text: "Loans",
        //   link: "#",
        //   roles: [1, 2, 4, 6],
        // },
        // {
        //   text: "Reports",
        //   link: "#",
        //   roles: [1, 2, 4, 6],
        // },
      ],
      status: false,
    },
    {
      text: "Settings",
      link: "/payroll/settings/staturary-components",
      icon: "ico-down",
      roles: [userRoles.TENANTADMIN, userRoles.HR, userRoles.FINANCEADMIN],

      menu: [
        // {
        //   text: "Tax",
        //   link: "/payroll/settings/tax",
        //   roles: [1, 2, 4, 6],
        // },
        {
          text: "Statutory Components",
          link: "/payroll/settings/staturary-components",
          roles: [userRoles.TENANTADMIN, userRoles.HR, userRoles.FINANCEADMIN],
        },
        // WILL BE IMPLEMETED LATER
        
        //  {
        //   text: "LOP Settings",
        //   link: "/payroll/settings/lop-settings",
        //   roles: [userRoles.TENANTADMIN, userRoles.HR, userRoles.FINANCEADMIN]
        // },
        {
          text: "Salary Components",
          link: "/payroll/settings/salary-components",
          roles: [userRoles.TENANTADMIN, userRoles.HR, userRoles.FINANCEADMIN],
        },
        {
          text: "Salary Templates",
          link: "/payroll/settings/salary-templates",
          roles: [userRoles.TENANTADMIN, userRoles.HR, userRoles.FINANCEADMIN],
        },
        {
          text: "Payment Schedule",
          link: "/payroll/settings/payment-schedule",
          roles: [userRoles.TENANTADMIN, userRoles.HR, userRoles.FINANCEADMIN],
        },
        // {
        //   text: "Preferences",
        //   link: "/payroll/settings/preferences",
        //   roles: [1, 2, 4, 6],
        // },
      ],
      status: false,
    },
  ]);
  return (
    <div className="lg:flex ">
      <DashboardSidebar />
      <div className="flex flex-1">
        <Aside submenu={submenu} setmenu={setSubmenu} />
        <Outlet />
      </div>
    </div>
  );
};

export default Payroll;
